<app-family-landing>
  <app-forgot-password-form [loginUrl]="'/auth/family/login'"></app-forgot-password-form>
</app-family-landing>
